export default __webpack_public_path__ + "static/media/ppi_light.77d73e78.png";